import React, { useState, useEffect } from "react";
import DropDownMenu from "../components/DropDownMenu";
import { useSelector, useDispatch } from "react-redux";
import {
  saveAsMappings,
  getInputColumnsData,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
import Button from "../components/Button";
import InputField from "../components/InputField";
import { showAddedRulesToast } from "../helpers";

const initialObject = {
  inputColumn: "",
  appliedRule: 5,
  skipCondition: "",
  skipConditionType: "value", // "value" | "empty"
};

const SKIP_CONDITION_TYPES = [
  { label: "Enter Value", value: "value" },
  { label: "Empty Cell", value: "empty" },
];

const SkipCondition = () => {
  const dispatch = useDispatch();
  const [conditionObject, setconditionObject] = useState(initialObject);
  const inputColsData = useSelector(getInputColumnsData);
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const usFlag = useSelector(getChangesFlag);

  useEffect(() => {
    if (state?.type === "skipCondition") {
      setconditionObject(state.data);
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state?.type, state?.data?._id]);

  const handleOnChange = (e) => {
    const { name, type, checked, value } = e.target;

    setconditionObject((prev) => {
      const updated = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };

      // When condition type changes to null/empty, clear the manual value
      if (name === "skipConditionType" && value !== "value") {
        updated.skipCondition = value; // store "null" or "empty" as the actual condition
      }

      // When switching back to value, clear it so user types a fresh value
      if (name === "skipConditionType" && value === "value") {
        updated.skipCondition = "";
      }

      return updated;
    });

    if (!usFlag) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  const handleAddNewRule = () => {
    dispatch(saveAsMappings(conditionObject));
    showAddedRulesToast(
      conditionObject.appliedRule,
      isInLocalEditMode ? "Updated" : "added",
    );
    reset();
  };

  const reset = () => {
    setconditionObject(initialObject);
    setIsInLocalEditMode(false);
  };

  const isValueType = conditionObject.skipConditionType === "value";

  const isSaveDisabled =
    conditionObject.inputColumn === "" ||
    (isValueType && conditionObject.skipCondition.trim() === "");

  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 p-2">
      <DropDownMenu
        label={"Select Input Column"}
        name="inputColumn"
        value={conditionObject.inputColumn}
        options={inputColsData.map((item) => ({
          label: item.inColChr,
          value: item.inColChr,
        }))}
        onChange={handleOnChange}
        required={true}
      />
      <DropDownMenu
        label={"Skip Condition Type"}
        name="skipConditionType"
        value={conditionObject.skipConditionType}
        options={SKIP_CONDITION_TYPES}
        onChange={handleOnChange}
        required={true}
      />
      {isValueType && (
        <InputField
          label={"Enter Skip Condition Value"}
          name={"skipCondition"}
          key={"skipConditionValue"}
          value={conditionObject.skipCondition}
          type="text"
          onChange={handleOnChange}
          required={true}
        />
      )}

      <div className="flex gap-4 col-span-2">
        <Button
          btnText={`${isInLocalEditMode ? "Update" : "Save"}`}
          handleOnClick={handleAddNewRule}
          disabled={isSaveDisabled}
        />
        <Button btnText={"Reset"} btnType="reset" handleOnClick={reset} />
      </div>
    </div>
  );
};

export default SkipCondition;
